import { useCallback } from 'react'
import { HistoryEvents } from '../utils'
import { useIsSsr } from '../../isSsr'

export const useRouter = () => {
  const isSsr = useIsSsr()

  const push = useCallback(
    (url: URL) => {
      if (!isSsr && url.href !== window.location.href) {
        window.history.pushState(null, '', url)
        window.dispatchEvent(new Event(HistoryEvents.PushState))
      }
    },
    [isSsr]
  )

  const replace = useCallback(
    (url: URL) => {
      if (!isSsr && url.href !== window.location.href) {
        window.history.replaceState(null, '', url)
        window.dispatchEvent(new Event(HistoryEvents.ReplaceState))
      }
    },
    [isSsr]
  )

  return {
    push,
    replace
  }
}
